module.exports = __webpack_public_path__ + "static/media/WIFI-MODULE.56b0f427.png";